import ClientTypesApi from '../../../../../core/api/ClientTypesApi'

export const PENDING_APPROVAL_START_EDITING_CLIENT_TYPES = 'PENDING_APPROVAL_START_EDITING_CLIENT_TYPES'
export const PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES = 'PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES'
export const PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES = 'PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES'
export const PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES = 'PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES'
export const PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED = 'PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED'

const clientTypesApi = new ClientTypesApi()

export const startEditingClientTypes = () => ({
  type: PENDING_APPROVAL_START_EDITING_CLIENT_TYPES
})

export const cancelEditingClientTypes = () => ({
  type: PENDING_APPROVAL_CANCEL_EDITING_CLIENT_TYPES
})

export function fetchClientTypes () {
  const request = clientTypesApi.fetchingClientTypes()

  return (dispatch) => {
    request.then(function (response) {
      dispatch(clientTypesApi.handleResponse(PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_FETCHED_CLIENT_TYPES, response))
    })
  }
}

export const clientTypeSelectedChanged = (clientType) => ({
  type: PENDING_APPROVAL_ADVISER_CLIENT_TYPE_PREFERENCES_CLIENT_TYPE_SELECTED_CHANGED,
  clientType
})

export const stopEditingClientTypes = () => ({
  type: PENDING_APPROVAL_STOP_EDITING_CLIENT_TYPES
})
